<template>
<div>
  <!-- Preloader Starts -->
  <div class="preloader">
    <div class="spinner"></div>
  </div>
  <!-- Preloader End -->

  <!-- Header Area Starts -->
  <header id='topHeader' class="header-area single-page">

    <div class="header-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-2">
            <div class="logo-area">
              <router-link to="/"><img style='width:256px;' src="static/assets/images/logo-light.png" alt="安阳文旅公共服务中心"></router-link>
            </div>
          </div>
          <div class="col-lg-10">
            <div class="custom-navbar">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="main-menu main-menu-light">
              <ul>
                <li class="active"><router-link to="/" @click.native='flushCom'>首页</router-link></li>
                <li><router-link to="/service" @click.native='flushCom'>全域文旅服务商</router-link></li>
                <li><router-link to="/train" @click.native='flushCom'>红色培训</router-link></li>
                <li><router-link to="/feature" @click.native='flushCom'>特色业务</router-link></li>
                <li><router-link to="/about" @click.native='flushCom'>关于我们</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- Header Area End -->

  <router-view></router-view>

  <!-- Footer Area Starts -->
  <footer class="footer-area section-padding" style='position: relative;'>
    <div class="footer-widget">
      <div class="container">
        <div class="row flexJBetween">
          <div class="col-xl-5 col-lg-5">
            <div class="single-widget-home mb-5 mb-lg-0">
              <img style='width: 250px;margin-bottom: 40px;' src="/static/assets/images/about/logo-w.png" alt="安阳古都旅游服务中心">
              <ul>
                <li class="mb-2">联系电话：0372-3721111 党建培训中心联系人：王主任15903722088</li>
                <li class="mb-2">工作时间：周一至周五08:30-18:00</li>
                <li class="mb-2">公司地址：河南省安阳市殷都区安阳殷墟考古文旅小镇办公区4楼</li>
              </ul>
            </div>
          </div>

          <div class="col-xl-5 offset-xl-1 col-lg-5">
            <div class="single-widge-home">
              <ul class='yjlink'>
                <li @click='goTop'><router-link to="/" @click.native='flushCom'>首页</router-link></li>
                <li @click='goTop'><router-link to="/service" @click.native='flushCom'>全域文旅服务商</router-link></li>
                <li @click='goTop'><router-link to="/train" @click.native='flushCom'>红色培训</router-link></li>
                <li @click='goTop'><router-link to="/feature" @click.native='flushCom'>特色业务</router-link></li>
                <li @click='goTop'><router-link to="/about" @click.native='flushCom'>关于我们</router-link></li>
              </ul>
              <div class="feed">
				  <div>
				  		<img style='width: 80px;height: 80px;border-radius: 6px;' src="static/assets/images/qr.jpg" alt="安阳文旅公共服务中心">
						<p>关注公众号</p>
						<p>了解更多资讯</p>
				  </div>
				  <div>
					  <img style='width: 80px;height: 80px;border-radius: 6px;' src="static/assets/images/xcx.jpg" alt="安阳文旅公共服务中心">
					  <p>扫一扫</p>
					  <p>查看更多资讯</p>
				  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-6" style='display: flex;align-items: center;justify-content: center;'>
          Copyright ©安阳文旅公共服务中心 版权所有ICP备案号：<a style='color:#8d8d8d' href="https://beian.miit.gov.cn/" target="_blank">豫ICP备19000925号-3</a> <!-- <img style='width: 12px;height: 12px;margin: 0 2px;' src="../static/assets/images/ba.png" alt=""> -->

          </div>
        </div>
      </div>
    </div>

  </footer>
  <!-- Footer Area End -->

</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return{
      isShowBig:false
    }
  },
  methods:{
    bigShow(){
      this.isShowBig = !this.isShowBig
    },
    goTop(){
      const topHeader = document.getElementById("topHeader");
      topHeader.scrollIntoView({ behavior: "smooth" });
    },
    flushCom(){
      this.$router.go(0);
    }
  }
}
</script>




// WEBPACK FOOTER //
// App.vue?5b41dd4a